module.exports = __webpack_public_path__ + "static/media/meetingW.7db63958.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/meetingW.svg
// module id = 544
// module chunks = 0